// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__xQpUf","close":"style_close__X-uza","dark":"style_dark__eDa2j"};